import React from "react";
import Title from '../../containers/title/title';
import Card from "./card/card";
import classes from './tournamentsCard.module.css';

const TournamentsCard = ({ tournaments, title, whiteBackground, /*setShowDetails,*/ /*setIsNew,*/ button, old, /*fetchTournamentDetails*/ }) => {
    
    return (
        <div className={classes.Container}>
            <Title title={title} />
            <div className={classes.CardList}>
                {tournaments.map((tournament) =>
                    <Card item={tournament} key={tournament.id} withList whiteBackground={whiteBackground} 
                    /*setShowDetails={setShowDetails}*/ /*setIsNew={setIsNew}*/ button={button} old={old} 
                    // fetchTournamentDetails={fetchTournamentDetails}
                    />
                )}
            </div>
        </div>
    )
}

export default TournamentsCard;